import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import { applyAppFuente, FUENTES_INTERFAZ } from '../../utils/appFondo';

const opciones = [
  { id: 'inter', nombre: 'Inter', muestra: 'Sans-serif limpia' },
  { id: 'roboto-slab', nombre: 'Roboto Slab', muestra: 'Serif robusta' },
  { id: 'merriweather', nombre: 'Merriweather', muestra: 'Serif editorial' },
  { id: 'coming-soon', nombre: 'Coming Soon', muestra: 'Manuscrita' }
];

const FuenteInterfazConfig = ({ userInfo, setUserInfo, setError, setSuccess }) => {
  const { updateUser } = useAuth();
  const [fuente, setFuente] = useState(userInfo?.fuenteInterfaz || 'inter');
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    setFuente(userInfo?.fuenteInterfaz || 'inter');
  }, [userInfo?.fuenteInterfaz]);

  const cambiarFuente = async (valor) => {
    if (valor === fuente || guardando) return;
    const anterior = fuente;
    setFuente(valor);
    applyAppFuente(valor);
    setGuardando(true);
    setError(null);
    setSuccess(null);

    try {
      const response = await api.patch('/user/me/fuente', { fuenteInterfaz: valor });
      setUserInfo(response.data.user);
      updateUser(response.data.user);
      setSuccess('Fuente de interfaz actualizada');
    } catch (error) {
      setFuente(anterior);
      applyAppFuente(anterior);
      setError(error.response?.data?.error || 'Error al actualizar la fuente');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="card mt-4">
      <div className="card-header"><h5>Fuente de la interfaz</h5></div>
      <div className="card-body">
        <span className="form-label d-block">Tipo de fuente</span>
        <div className="fuente-interfaz-opciones" role="radiogroup" aria-label="Tipo de fuente">
          {opciones.map(opcion => {
            const activa = fuente === opcion.id;
            const familia = FUENTES_INTERFAZ[opcion.id]?.family || 'inherit';
            return (
              <button
                key={opcion.id}
                type="button"
                className={`fuente-interfaz-opcion${activa ? ' activa' : ''}`}
                onClick={() => cambiarFuente(opcion.id)}
                disabled={guardando}
                role="radio"
                aria-checked={activa}
                style={{ fontFamily: familia }}
              >
                <span className="fuente-interfaz-opcion__muestra">Aa</span>
                <span className="fuente-interfaz-opcion__texto">
                  <strong>{opcion.nombre}</strong>
                  <small>{opcion.muestra}</small>
                </span>
                <span className="fuente-interfaz-opcion__estado" aria-hidden="true">
                  {activa ? '✓' : ''}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FuenteInterfazConfig;
